import { db } from "config/firebaseConfig";
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { Watcher } from "hooks/DeviceWatcher";
import React, { useEffect, useState } from "react";
import {
  FaAndroid,
  FaApple,
  FaAppStoreIos,
  FaBatteryEmpty,
  FaBatteryFull,
  FaBatteryHalf,
  FaBatteryQuarter,
  FaBatteryThreeQuarters,
  FaWifi,
} from "react-icons/fa";
import { GiRadarSweep } from "react-icons/gi";
import { useNavigate } from "react-router-dom";

const DeviceCard = ({ id, user }) => {
  const [device, setDevice] = useState(null);

  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, `users/${user.email}/devices`, id),
      (doc) => {
        setDevice(doc.data());
      }
    );

    return () => {
      unsub();
    };
  }, [id, user.email]);

  useEffect(() => {
    const getTime = async () => {
      const docId = await getDoc(
        doc(db, `users/${user.email}/devices`, id)
      ).then((doc) => {
        return doc.id;
      });
      Watcher(docId, user.email);
    };
    getTime();
  }, [id, user.email]);

  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/devices/${id}`, {
      state: { deviceId: device.deviceName, userId: user.email },
    });
    console.log("click logic");
  };
  return (
    device && (
      <div
        onClick={handleClick}
        className="flex flex-col bg-header/30 border border-header rounded  w-full  lg:w-[350px] md:w-[320px] m-5 shadow-xl h-fit hover:-translate-y-2  transition-all duration-300 ease-out cursor-pointer"
      >
        <div className=" py-3 px-2 items-center justify-center text-center bg-header/60">
          <span>{device.deviceName}</span>
        </div>
        <div className="flex flex-col py-4 px-5 space-y-2  text-xs">
          <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
            <span>Brand</span>
            <div className="flex items-center  justify-between px-2">
              <span>{device.brand}</span>
              {device.brand === "Apple" ? (
                <FaApple className="w-6 h-6 text-white" />
              ) : (
                <FaAndroid className="w-6 h-6 text-green-500" />
              )}
            </div>
          </div>

          <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
            <span>Model</span>
            <div className="flex items-center  w-full whitespace-nowrap  justify-between px-2">
              <span>{device.modelName}</span>
            </div>
          </div>
          <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
            <span>Year </span>
            <div className="flex items-center  justify-end px-2">
              <span>{device.year}</span>
            </div>
          </div>

          <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
            <span>Battery </span>
            <div className="flex items-center  justify-between px-2">
              <span>{device.battery.state}</span>

              {device.battery.level <= 5 ? (
                <FaBatteryEmpty className="w-6 h-6 text-red-700" />
              ) : device.battery.level <= 25 ? (
                <FaBatteryQuarter className="w-6 h-6 text-red-500" />
              ) : device.battery.level <= 50 ? (
                <FaBatteryHalf className="w-6 h-6 text-yellow-300" />
              ) : device.battery.level <= 75 ? (
                <FaBatteryThreeQuarters className="w-6 h-6 text-orange-400" />
              ) : (
                device.battery.level <= 100 && (
                  <FaBatteryFull className="w-6 h-6 text-green-500" />
                )
              )}
            </div>
          </div>

          <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
            <span>Network </span>
            <div className="flex items-center  justify-between px-2">
              <span>
                {device.network.details.strength &&
                  device.network.details.strength}
                %
              </span>
              <FaWifi className="w-6 h-6" />
            </div>
          </div>
          <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
            <span>OS </span>
            <div className="flex items-center  justify-between px-2">
              <span>{device.osName}</span>
              <FaAppStoreIos className="w-6 h-6" />
            </div>
          </div>
          <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
            <span>OS Version </span>
            <div className="flex items-center  justify-end px-2">
              <span>{device.osVersion}</span>
            </div>
          </div>

          <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
            <span className="text-primary">Tracking </span>
            <div className="flex items-center  justify-between px-2">
              <span
                className={`${
                  device.tracking ? " text-green-400" : " text-slate-400"
                }`}
              >
                {device.tracking ? "Active" : "Inactive"}
              </span>
              <span>
                {device.tracking ? (
                  <GiRadarSweep className="w-6 h-6 animate-spin text-green-400" />
                ) : (
                  <GiRadarSweep className="w-6 h-6" />
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default DeviceCard;
